import * as React from 'react'
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'

export interface ScrollAreaProps extends React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> {
  keepScrollHistory?: boolean
  viewportClassName?: string
}

const ScrollArea = React.forwardRef<React.ElementRef<typeof ScrollAreaPrimitive.Root>, ScrollAreaProps>(
  ({className, viewportClassName, keepScrollHistory, children, ...props}, ref) => {
    const viewportRef = React.useRef<HTMLDivElement>(null)

    return (
      <ScrollAreaPrimitive.Root ref={ref} style={{position: 'relative', overflow: 'hidden'}} {...props}>
        <ScrollAreaPrimitive.Viewport ref={viewportRef} style={{width: '100%', borderRadius: 'inherit', display: 'block'}}>
          {children}
        </ScrollAreaPrimitive.Viewport>
        <ScrollBar />
        <ScrollAreaPrimitive.Corner />
      </ScrollAreaPrimitive.Root>
    )
  },
)
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName

const ScrollBar = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>
>(({className, orientation = 'vertical', ...props}, ref) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    style={{
      display: 'flex',
      touchAction: 'none',
      userSelect: 'none',
      transition: 'colors',
      ...(orientation === 'vertical' ? {height: '100%', width: '2.5rem', borderLeft: '1px solid transparent', padding: '1px'} : {}),
      ...(orientation === 'horizontal' ? {height: '2.5rem', flexDirection: 'column', borderTop: '1px solid transparent', padding: '1px'} : {}),
      ...props.style,
    }}
    {...props}>
    <ScrollAreaPrimitive.ScrollAreaThumb style={{flex: 1, borderRadius: '50%', backgroundColor: 'var(--border-color)'}} />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
))
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName

export {ScrollArea, ScrollBar}
